type ArgumentTypes<F extends Function> = F extends (...args: infer A) => any
  ? A
  : never;

export function useLoading<
  T extends (...args: ArgumentTypes<T>) => Promise<unknown | void>,
>(asyncCb: T, allowMultipleCalls = false) {
  const loading = ref(false);
  let activePromise: ReturnType<T> | undefined;

  function call(...args: ArgumentTypes<T>): ReturnType<T> {
    loading.value = true;

    if (!allowMultipleCalls && loading.value && activePromise) {
      return activePromise;
    }

    return (activePromise = asyncCb(...args).finally(() => {
      activePromise = undefined;
      loading.value = false;
    }) as ReturnType<T>);
  }

  return {
    loading,
    call,
  };
}
